import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-empty-state-button', {
    display: 'inline-block',
    border: '1px solid ' + applyColor(DesignTokens.color.font.default.subtle, '#cbcbcb'),
    height: '24px',
    marginTop: '29px',
    lineHeight: '22px',
    fontSize: '12px',
    padding: '0 24px',
    cursor: 'default',
    backgroundColor: 'none',
    color: applyColor(DesignTokens.color.font.default.secondary, 'rgba(0,0,0,0.7)'),
    textDecoration: 'none',
    outline: 0,
    whiteSpace: 'nowrap',
    borderRadius: '1px',
    /* error: '-o-border-radius': '1px', */
    /* error: '-moz-border-radius': '1px', */
    '-webkit-border-radius': '1px',
    /* error: '-khtml-border-radius': '1px', */
});

cssRule('.tb-empty-state-button:hover, .tb-empty-state-button:focus', {
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
    color: applyColor(DesignTokens.color.font.default.default, 'rgba(0,0,0,0.8)'),
    textDecoration: 'none',
    outline: 0,
});

cssRule('.tb-empty-state-button:active', {
    backgroundColor: 'none',
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\'',
    filter: 'alpha(opacity=80)',
    opacity: 0.8,
    outline: 0,
});

cssRule('.tb-outline-button', {
    display: 'inline-block',
    border: '1px solid #666',
    height: '21px',
    lineHeight: '21px',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '0 24px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    textDecoration: 'none',
    outline: 0,
    whiteSpace: 'nowrap',
    borderRadius: '1px',
    /* error: '-o-border-radius': '1px', */
    /* error: '-moz-border-radius': '1px', */
    '-webkit-border-radius': '1px',
    /* error: '-khtml-border-radius': '1px', */
});

cssRule('.tb-outline-button:hover', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.hover, '#ebebeb'),
});

cssRule('.tb-outline-button:focus', {
    borderColor: applyColor(DesignTokens.color.utility.focus.default.default, '#3498DB'),
    /* error: '-moz-box-shadow': '0 0 4px 0 #3498db', */
    '-webkit-box-shadow': '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
    boxShadow: '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
    textDecoration: 'none',
});

cssRule('.tb-outline-button:active', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#ccc'),
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.default, '#333'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-outline-button.tb-filled-when-selected', {
    backgroundColor: 'transparent',
});

cssRule('.tb-outline-button.tb-filled-when-selected.tb-selected', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-outline-button.tb-disabled', {
    cursor: 'default',
    backgroundColor: 'transparent',
    borderColor: applyColor(DesignTokens.color.font.default.disabled, '#bfbfbf'),
    color: applyColor(DesignTokens.color.font.default.subtle, '#bfbfbf'),
});

cssRule('.tb-outline-button.tb-go-button', {
    fontWeight: 'bold',
    backgroundColor: applyColor(DesignTokens.color.link.inline.default.default, '#1a699e'),
    borderColor: applyColor(DesignTokens.color.link.inline.default.default, '#1a699e'),
    color: applyColor(DesignTokens.color.font.inverse.default, '#fff'),
});

cssRule('.tb-outline-button.tb-go-button:hover', {
    backgroundColor: applyColor(DesignTokens.color.link.inline.default.hover, '#2a79af'),
    borderColor: applyColor(DesignTokens.color.link.inline.default.hover, '#2a79af'),
});

cssRule('.tb-outline-button.tb-go-button:focus', {
    borderColor: applyColor(DesignTokens.color.utility.focus.default.default, '#3498DB'),
    /* error: '-moz-box-shadow': '0 0 4px 0 #3498db', */
    '-webkit-box-shadow': '0 0 4px 0 '+applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
    boxShadow: '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
});

cssRule('.tb-outline-button.tb-go-button:active', {
    backgroundColor: applyColor(DesignTokens.color.link.inline.default.active, '#15557f'),
    borderColor: applyColor(DesignTokens.color.link.inline.default.active, '#15557f'),
});

cssRule('.tb-outline-button.tb-go-button.tb-disabled', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.disabled, '#c8c8c8'),
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.disabled, '#c8c8c8'),
});

cssRule('.tb-outline-button.tb-dark', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#FAFAFA'),
});

cssRule('.tb-outline-button.tb-dark:active', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
});

cssRule('.tb-outline-button.tb-dark.tb-disabled', {
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.disabled, '#dadada'),
    color: applyColor(DesignTokens.color.font.default.disabled, '#dadada'),
});

cssRule('button.tb-outline-button', {
    height: '23px',
});

cssRule('.tb-small-outline-button', {
    display: 'inline-block',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    width: '21px',
    height: '21px',
    lineHeight: '21px',
    cursor: 'pointer',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-small-outline-button:hover, .tb-small-outline-button:focus', {
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-small-outline-button:active', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    borderColor: applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-small-outline-button.tb-disabled', {
    cursor: 'default',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=25)\'',
    filter: 'alpha(opacity=25)',
    opacity: 0.25,
});

cssRule('.tb-icon-button', {
    display: 'inline-block',
    width: '23px',
    height: '23px',
    cursor: 'pointer',
});

cssRule('.tb-icon-button.tb-small', {
    width: '19px',
    height: '19px',
});

cssRule('.tb-filter-panel-toggle-button', {
    display: 'inline-block',
    width: '29px',
    height: '21px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    background: 'url(img/filter_toggle_normal.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'pointer',
});

cssRule('.tb-filter-panel-toggle-button.tb-selected', {
    background: 'url(img/filter_toggle_selected.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-filter-panel-toggle-button:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#333'),
});

cssRule('.tb-toggle-button', {
    position: 'relative',
    display: 'inline-block',
    width: '58px',
    height: '21px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-toggle-button-handle', {
    width: '29px',
    cursor: 'pointer',
});

cssRule('.tb-toggle-button-handle:hover', {
    top: '-1px',
    bottom: '-1px',
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#333'),
    zIndex: 1,
});

cssRule('.tb-grid-mode-handle-icon', {
    background: 'url(img/view_toggle_grid_normal.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-grid-mode-handle-icon.tb-selected', {
    background: 'url(img/view_toggle_grid_selected.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-list-mode-handle-icon', {
    background: 'url(img/view_toggle_list_normal.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-list-mode-handle-icon.tb-selected', {
    background: 'url(img/view_toggle_list_selected.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-text-button', {
    border: 'none',
    backgroundColor: 'transparent',
    font: 'inherit',
    display: 'inline-block',
    height: '23px',
    lineHeight: '23px',
    padding: '0 6px',
    cursor: 'pointer',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    textDecoration: 'none',
});

cssRule('.tb-text-button:hover', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    textDecoration: 'none',
});

cssRule('.tb-text-button.tb-disabled, .tb-text-button.tb-disabled:hover, .tb-text-button.tb-disabled:focus', {
    cursor: 'default',
    backgroundColor: 'transparent',
    color: applyColor(DesignTokens.color.font.default.disabled, '#e1e1e1'),
});

cssRule('.tb-text-button.tb-disabled.tb-dark, .tb-text-button.tb-disabled:hover.tb-dark, .tb-text-button.tb-disabled:focus.tb-dark', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#dadada'),
});

cssRule('.tb-subplace-tab-button', {
    display: 'inline-block',
    verticalAlign: 'top',
    textDecoration: 'none',
    cursor: 'pointer',
    paddingLeft: '6px',
    marginRight: '20px',
});

cssRule('.tb-subplace-tab-button >.tb-label', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '31px',
    lineHeight: '31px',
    /* error: fontWeight: 'fongWeight', */
    fontSize: '15px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    borderBottom: '3px solid transparent',
    marginRight: '6px',
});

cssRule('.tb-subplace-tab-button >.tb-count', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '31px',
    lineHeight: '31px',
    fontSize: '12px',
    borderBottom: '3px solid transparent',
    paddingLeft: '6px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c'),
    paddingRight: '6px',
});

cssRule('.tb-subplace-tab-button:hover, .tb-subplace-tab-button:focus', {
    textDecoration: 'none',
});

cssRule('.tb-subplace-tab-button:hover >.tb-label, .tb-subplace-tab-button:focus >.tb-label', {
    color: applyColor(DesignTokens.color.font.default.default, '#000'),
});

cssRule('.tb-subplace-tab-button.tb-selected >.tb-label, .tb-subplace-tab-button.tb-selected:hover >.tb-label', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    fontWeight: 'bold',
    borderBottom: '3px solid ' + applyColor(DesignTokens.color.link.inline.default.hover, '#2a5775'),
});

cssRule('.tb-subplace-tab-button.tb-selected >.tb-count, .tb-subplace-tab-button.tb-selected:hover >.tb-count', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-tabs-banner .tb-subplace-tab-button >.tb-label', {
    height: '41px',
    lineHeight: '41px',
    fontSize: '18px',
});

cssRule('.tb-tabs-banner .tb-subplace-tab-button >.tb-count', {
    height: '41px',
    lineHeight: '41px',
});

cssRule('.tb-tabs-banner', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 'auto',
    left: 0,
    height: '60px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    borderBottom: '3px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-orange-button', {
    display: 'inline-block',
    lineHeight: '34px',
    marginTop: '29px',
    padding: '6px 18px',
    textAlign: 'center',
    fontFamily: 'inherit',
    fontSize: '18px',
    fontWeight: 'normal',
    border: 0,
    outline: 0,
    borderRadius: '1px',
    /* error: '-o-border-radius': '1px', */
    /* error: '-moz-border-radius': '1px', */
    '-webkit-border-radius': '1px',
    /* error: '-khtml-border-radius': '1px', */
    transition: 'background-color 150ms ease-in',
    /* error: '-o-transition': 'background-color 150ms ease-in', */
    '-moz-transition': 'background-color 150ms ease-in',
    '-webkit-transition': 'background-color 150ms ease-in',
    /* error: '-khtml-transition': 'background-color 150ms ease-in', */
});

cssRule('.tb-orange-button:hover, .tb-orange-button:focus', {
    cursor: 'pointer',
    textDecoration: 'none',
    outline: 0,
});

cssRule('.tb-orange-button.tb-button-busy', {
    padding: '6px 70px',
    position: 'relative',
    color: applyColor(DesignTokens.color.font.inverse.default, '#fff'),
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=35)\'',
    filter: 'alpha(opacity=35)',
    opacity: 0.35,
    transition: 'none',
    /* error: '-o-transition': 'none', */
    '-moz-transition': 'none',
    '-webkit-transition': 'none',
    /* error: '-khtml-transition': 'none', */
    cursor: 'default',
});

cssRule('.tb-orange-button.tb-button-busy .tb-icon-spinner-large', {
    position: 'absolute',
    top: 'auto',
    right: '19px',
    bottom: 'auto',
    left: 'auto',
});

cssRule('.tb-login-form-container .tb-orange-button', {
    backgroundColor: applyColor(DesignTokens.color.component.background.cta.default.default, '#355c80'),
    marginTop: '15px',
});

cssRule('.tb-login-form-container .tb-orange-button:hover, .tb-login-form-container .tb-orange-button:focus', {
    backgroundColor: applyColor(DesignTokens.color.component.background.cta.default.active, '#222636'),
});

cssRule('.tb-login-form-container .tb-orange-button.tb-button-busy:hover, .tb-login-form-container .tb-orange-button.tb-button-busy:focus', {
    backgroundColor: applyColor(DesignTokens.color.component.background.cta.default.hover, '#222636'),
});

cssRule('.tb-login-form-container .tb-orange-button.tb-disabled', {
    backgroundColor: applyColor(DesignTokens.color.component.background.cta.default.disabled, '#355c80'),
    borderColor: applyColor(DesignTokens.color.component.background.cta.default.disabled, '#355c80'),
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=35)\'',
    filter: 'alpha(opacity=35)',
    opacity: 0.35,
});

cssRule('.tb-login-form-container .tb-orange-button.tb-disabled:hover, .tb-login-form-container .tb-orange-button.tb-disabled:focus', {
    borderColor: applyColor(DesignTokens.color.component.background.cta.default.disabled, '#355c80'),
});

cssRule('.tb-login-form-container .tb-button-login:not(.tb-button-busy) .tb-icon-sign-in-arrow', {
    display: 'inline-block',
    verticalAlign: 'middle',
    backgroundImage: 'url(img/SignIn_Arrow_White.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    width: '18px',
    height: '18px',
    marginLeft: '12px',
});

cssRule('.tb-login-form-container', {
    display: 'inline-block',
    margin: '0 35px',
});

cssRule('.tb-header-menu-button:focus', {
    outline: '1px solid '+applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
    /* error: '-moz-box-shadow': '0 0 4px #3498db', */
    '-webkit-box-shadow': '0 0 4px #3498db',
    boxShadow: '0 0 4px '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
});

